// ========================================
// 熨斗紙：再クリックで選択解除
// ========================================

document
  .querySelectorAll('.noshi-option > input[type="radio"]')
  .forEach((radio) => {
    const option = radio.closest(".noshi-option");
    const tooltip = option.querySelector(".noshi-option__tooltip");

    radio.addEventListener("click", function () {
      if (this.dataset.wasChecked === "true") {
        this.checked = false;
        this.dataset.wasChecked = "false";

        // 選択解除と同時に吹き出しも消す
        tooltip.style.display = "none";

        return;
      }

      document
        .querySelectorAll(`input[name="${this.name}"]`)
        .forEach((item) => {
          item.dataset.wasChecked = "false";
        });

      this.dataset.wasChecked = "true";
      tooltip.style.removeProperty("display");
    });

    // カーソルを外したら通常のhover動作に戻す
    option.addEventListener("mouseleave", () => {
      tooltip.style.removeProperty("display");
    });
  });

// ========================================
// 内熨斗・外熨斗の選択
// ========================================
document.querySelectorAll(".noshi").forEach((noshi) => {
  const noshiPapers = noshi.querySelectorAll(
    'input[name="properties[熨斗紙]"]'
  );

  const positionRadios = noshi.querySelectorAll('input[name="noshi_position"]');

  const positionValue = noshi.querySelector(".noshi__position-value");

  if (!positionValue) return;

  const updatePositionValue = () => {
    const selectedPaper = noshi.querySelector(
      'input[name="properties[熨斗紙]"]:checked'
    );

    // 熨斗紙なし → 掛け方も送信しない
    if (!selectedPaper) {
      positionValue.value = "";
      positionValue.disabled = true;
      return;
    }

    // ユーザーが内・外を選択しているか
    const selectedPosition = noshi.querySelector(
      'input[name="noshi_position"]:checked'
    );

    // 未選択なら内熨斗
    positionValue.value = selectedPosition ? selectedPosition.value : "内熨斗";

    positionValue.disabled = false;
  };

  noshiPapers.forEach((radio) => {
    radio.addEventListener("click", updatePositionValue);
  });

  positionRadios.forEach((radio) => {
    radio.addEventListener("change", updatePositionValue);
  });

  updatePositionValue();
});

const noshiOptions = document.querySelectorAll(".noshi-option");

noshiOptions.forEach((option) => {
  option.addEventListener("mouseenter", () => {
    const selectedOption = document
      .querySelector('.noshi-option > input[type="radio"]:checked')
      ?.closest(".noshi-option");

    // 選択中とは別のカードをhoverしたとき
    if (selectedOption && selectedOption !== option) {
      const selectedTooltip = selectedOption.querySelector(
        ".noshi-option__tooltip"
      );

      if (selectedTooltip) {
        selectedTooltip.style.display = "none";
      }
    }
  });

  option.addEventListener("mouseleave", () => {
    const selectedOption = document
      .querySelector('.noshi-option > input[type="radio"]:checked')
      ?.closest(".noshi-option");

    if (selectedOption) {
      const selectedTooltip = selectedOption.querySelector(
        ".noshi-option__tooltip"
      );

      if (selectedTooltip) {
        selectedTooltip.style.removeProperty("display");
      }
    }
  });
});
